// Module
var code = "<div class=container> <div class=loader> <div class=outer></div> <div class=inner></div> </div> <ul class=messages data-ref=messages></ul> </div>";
// Exports
export default code;